import script from "./suggestDioalog.vue?vue&type=script&setup=true&lang=js"
export * from "./suggestDioalog.vue?vue&type=script&setup=true&lang=js"

import "./suggestDioalog.vue?vue&type=style&index=0&id=3bfb062f&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bfb062f"]])

export default __exports__